// Política de contraseñas de la plataforma.
// Espejo del validador del backend (backend/app/routers/auth.py
// _validate_password_strength): mínimo 8 caracteres, al menos una letra
// y un número. Devuelve la clave i18n del primer error, o null si es válida.
export function passwordPolicyError(password) {
  const value = password || '';
  if (value.length < 8) return 'auth.passwordTooShort8';
  if (value.length > 128) return 'auth.passwordTooLong';
  if (!/[a-zA-Z]/.test(value)) return 'auth.passwordNeedsLetter';
  if (!/\d/.test(value)) return 'auth.passwordNeedsNumber';
  return null;
}
